module.exports = __webpack_public_path__ + "media/images/writer-offering-policy01-0cd0a525602411e2033a67dc0aaff84c.png";